<template>
    <Card :padding="20" shadow>
        <i-form :model="dados_usuario" :rules="rules_validate" ref="usuario" label-position="top">
            <Row :gutter="16">
                <i-col :xs="24" :md="12" :lg="8">
                    <form-item label="Nome" prop="nome">
                        <i-input clearable v-model="dados_usuario.nome" placeholder="Nome..." size="large"></i-input>
                    </form-item>
                </i-col>
                <i-col :xs="24" :md="12" :lg="8">
                    <form-item label="E-mail" prop="email">
                        <i-input clearable v-model="dados_usuario.email" placeholder="E-mail..." size="large"></i-input>
                    </form-item>
                </i-col>
                <i-col :xs="24" :md="8" :lg="8">
                    <form-item label="Celular" prop="celular">
                        <div class="ivu-form-item">
                            <the-mask class="ivu-input ivu-input-large" v-model="dados_usuario.celular"
                                      :mask="['(##) ####-####', '(##) #####-####']"/>
                        </div>
                    </form-item>
                </i-col>
                <i-col :xs="24" :md="8" :lg="6">
                    <form-item label="Departamento" prop="usuario_departamento">
                        <i-select filterable clearable v-model="dados_usuario.usuario_departamento" @input="onSelectDep()" size="large">
                            <i-option v-for="(departamento, key) in departamentos" :value="departamento" :key="key">
                              {{ departamento }}
                            </i-option>
                        </i-select>
                    </form-item>
                </i-col>
                <i-col :xs="24" :md="8" :lg="6">
                    <form-item label="Cargo" prop="usuario_cargo">
                        <i-select filterable clearable v-model="dados_usuario.usuario_cargo" size="large">
                            <i-option v-for="cargo in cargos_filtro" :value="cargo.id_cargo" :key="cargo.id_cargo">{{
                                cargo.nome }}
                            </i-option>
                        </i-select>
                    </form-item>
                </i-col>
                <i-col :xs="24" :md="12" :lg="6">
                    <form-item label="Senha" prop="senha">
                        <i-input clearable type="password" v-model="dados_usuario.senha" placeholder="senha..."
                                 autocomplete="off"
                                 size="large"></i-input>
                    </form-item>
                </i-col>
                <i-col :xs="24" :md="12" :lg="6">
                    <form-item label="Confirmar Senha" prop="senha2">
                        <i-input clearable type="password" v-model="dados_usuario.senha2" placeholder="Confirmar senha..."
                                 size="large"></i-input>
                    </form-item>
                </i-col>
            </Row>
            <Divider orientation="left">Endereço</Divider>
            <Row :gutter="16">
                <i-col :xs="24" :md="12" :lg="8">
                    <FormItem label="CEP" prop="end_cep">
                        <div class="ivu-form-item">
                            <the-mask class="ivu-input ivu-input-large" v-model="dados_usuario.end_cep"
                                      :mask="['#####-###']" :masked="true" @input="onCEP()"/>
                        </div>
                    </FormItem>
                </i-col>
                <i-col :xs="24" :md="12" :lg="8">
                    <form-item label="Estado" prop="end_estado">
                        <i-select filterable clearable v-model="dados_usuario.end_estado" @input="onChangeUF" size="large">
                            <i-option v-for="estado in estados" :value="estado.id_estado" :key="estado.id_estado">
                              {{ estado.estado }}
                            </i-option>
                        </i-select>
                    </form-item>
                </i-col>
                <i-col :xs="24" :md="12" :lg="8">
                    <form-item label="Cidade" prop="end_cidade">
                        <i-select filterable clearable v-model="dados_usuario.end_cidade" size="large">
                            <i-option v-for="cidade in cidades" :value="cidade.nome" :key="cidade.nome">{{ cidade.nome
                                }}
                            </i-option>
                        </i-select>
                    </form-item>
                </i-col>
                <i-col :xs="24" :md="12" :lg="8">
                    <form-item label="Bairro" prop="end_bairro">
                        <i-input clearable v-model="dados_usuario.end_bairro" size="large"></i-input>
                    </form-item>
                </i-col>
                <i-col :xs="24" :md="16" :lg="12">
                    <form-item label="Rua" prop="end_rua">
                        <i-input clearable v-model="dados_usuario.end_rua" size="large"></i-input>
                    </form-item>
                </i-col>
                <i-col :xs="24" :md="8" :lg="4">
                    <form-item label="Número" prop="end_numero">
                        <i-input clearable v-model="dados_usuario.end_numero" size="large"></i-input>
                    </form-item>
                </i-col>
            </Row>
            <template v-if="idUser === dados_usuario.id_pessoa">
                <Divider orientation="left">Tema</Divider>
                <Row :gutter="16">
                    <i-col :xs="24">
                        <form-item>
                            <vs-radio class="mr-4" v-model="theme" vs-value="light">Light</vs-radio>
                            <vs-radio class="mr-4" v-model="theme" vs-value="dark">Dark</vs-radio>
                            <vs-radio v-model="theme" vs-value="semi-dark">Semi Dark</vs-radio>
                        </form-item>
                    </i-col>
                </Row>
            </template>
            <template v-if="permissaoAlterar">
                <Divider orientation="left">Permissões</Divider>
                <Row :gutter="16">
                    <i-col :xs="24">
                        <form-item>
                            <vs-col v-for="(item, key) in modules" :key="key" vs-w="4">
                                <vs-checkbox :icon="item.icon" v-model="item.value" :vs-value="item.value" @input="setAllModule(item,key)">{{ item.label }}</vs-checkbox>
                                <vs-col v-for="(children, index) in item.children" :key="index">
                                    <vs-checkbox v-model="permission" :vs-value="children.label+children.value" v-if="item.label == children.label" @input="setItemPermission(item,children,key)">{{ children.value }}</vs-checkbox>
                                </vs-col>
                            </vs-col>
                        </form-item>
                    </i-col>
                </Row>
            </template>
        </i-form>
        <div class="floating-btn" v-show="ativar_botao">
            <i-button @click="validar('usuario')" icon="md-checkmark" shape="circle" type="primary"></i-button>
        </div>
    </Card>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"
    import _ from "lodash"
    const {consultarCEP} = require("../helpers/utils.js")
    export default {
        props: ["id"],
        components: {
            TheMask: () => import("vue-the-mask").then(({TheMask}) => TheMask)
        },
        data() {
            /**
             * Confirma se os dois valores de senha são iguais
             */
            const validatorPassword = (rule, value, callback) => {
                if (value !== this.dados_usuario.senha) {
                    callback(new Error(rule.message))
                } else {
                    callback()
                }
            }
            /**
             * Custom validator de selects, pois o do iView não funciona como esperado
             */
            const validatorSelect = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error(rule.message))
                } else {
                    callback()
                }
            }
            return {
                dados_usuario: {
                    id_pessoa: 0,
                    nome: "",
                    email: "",
                    end_cep: "",
                    end_estado: "",
                    end_cidade: "",
                    end_bairro: "",
                    end_rua: "",
                    end_numero: "",
                    senha: "",
                    senha2: "",
                    usuario_departamento: "",
                    usuario_cargo: "",
                    github_token: "",
                    aws_key: "",
                    aws_secret: "",
                    permissao:[],
                },
                rules_validate: {
                    nome: [
                        {
                            required: true,
                            message: "Informe o Nome",
                            min: 9,
                            trigger: "blur"
                        }
                    ],
                    email: [
                        {
                            required: true,
                            message: "Informe o email",
                            trigger: "blur"
                        },
                        {
                            type: "email",
                            message: "E-mail inválido",
                            trigger: "blur"
                        }
                    ],
                    senha: [
                        {
                            required: true,
                            message: "Informe a Senha",
                            trigger: "blur"
                        }
                    ],
                    senha2: [
                        {
                            required: true,
                            validator: validatorPassword,
                            message: "As senhas não são iguais",
                            trigger: "blur"
                        }
                    ],
                    /*end_cep: [
                        {
                            required: true,
                            message: "Informe o CEP",
                            min: 9,
                            max: 9,
                            trigger: "blur"
                        }
                    ],*/
                    usuario_departamento: [
                        {
                            required: true,
                            validator: validatorSelect,
                            message: "Informe o departamento",
                            trigger: "change"
                        }
                    ],
                    usuario_cargo: [
                        {
                            required: true,
                            validator: validatorSelect,
                            message: "Informe o cargo",
                            trigger: "change"
                        }
                    ]
                },
                ativar_botao: false,
                estados: [],
                cidades: [],
                //Cidade: Chave para armazenamento temporario de dados que vem do BD, pois precisa fazer a consulta das cidades conforme o estado selecionado
                cidade: "",
                departamentos: [],
                cargos: [],
                cargos_filtro: [],
                // valores de permissoes para o usuário
                modules:[],
                permission:[],
                // inicia com os modulos padroes
                permissions:[{ "id": 1, "label": "Novo Ticket" }, { "id": 2, "label": "Fale com a Gestão" }],
            }
        },
        async created() {
            if(this.permissaoAlterar){
                await this.getModules()
            }
            await this.getCargos()
            await this.getEstados()
            this.dados_usuario.permissao = this.permissions
            /**
             * Caso possua id nas props consulto os dados do cadastro [edição]
             */
            if (this.id > 0) {
                this.$Spin.show()
                await this.getUsuario(this.id)
            }
        },
        computed: {
            ...mapGetters(['idUser']),
            theme: {
                get() {
                    return this.$store.state.theme
                },
                set(val) {
                    this.updateTheme(val)
                }
            },
            permissaoAlterar() {
                /**
                 * Permissão: Administração
                 */
                return [1, 2].includes(this.$store.getters.usuario.usuario_cargo)
            }
        },
        methods: {
            ...mapActions(['updateTheme','updateUser']),
            /**
             * Antes de Salvar valida os dados dos inputs
             */
            validar(name) {
                this.$refs[name].validate(valid => {
                    if (!valid) {
                        this.$Message.error("Há campos não informados!")
                    } else {
                        this.salvar()
                    }
                })
            },
            /**
             * Atualiza um cadastro existente, ou cria um novo
             */
            async salvar() {
                let dados_usuario = this.dados_usuario
                let dados = [dados_usuario.permissao]
                let novo_ticket = true
                let fale_gestao = true
                dados.filter(item =>{
                    item.filter(value =>{
                        if(value.id == 1){
                            novo_ticket = false
                        }
                        if(value.id == 2){
                            fale_gestao = false
                        }
                    })
                })
                if(fale_gestao){
                    dados_usuario.permissao.unshift({ "id": 2, "label": "Fale com a Gestão" })
                }
                if(novo_ticket){
                    dados_usuario.permissao.unshift({"id": 1, "label": "Novo Ticket"})
                }
                try {
                    const id_pessoa = dados_usuario.id_pessoa
                    const URI = `pessoa`
                    if (id_pessoa == 0) {
                        /**
                         * Cria um novo cadastro
                         */
                        const {data} = await this.$axios.post(
                            URI,
                            dados_usuario
                        )
                        this.dados_usuario.id_pessoa = data.id_pessoa
                    } else {
                        /**
                         * Atualiza um cadastro
                         */
                        await this.$axios.put(
                            `${URI}/${id_pessoa}`,
                            dados_usuario
                        )
                        if(this.idUser == dados_usuario.id_pessoa){
                            this.updateUser(dados_usuario)
                        }
                    }
                    this.$Message.success("Dados salvos com sucesso!")
                    this.ativar_botao = false
                    this.$Spin.hide()
                } catch (error) {
                    console.warn(error)
                    this.$Message.error(`Erro! ${error}`)
                    this.$Spin.hide()
                }
            },
            /**
             * Busca os dados do usuário para edição
             */
            async getUsuario(id_usuario) {
                try {
                    const URI = `pessoa/${id_usuario}`
                    const {data} = await this.$axios.get(URI)

                    this.dados_usuario = data
                    // seleciona as permissoes que o usuario possui
                    if(this.permissaoAlterar){
                        let permission = data.permissao
                        if(permission){
                            this.setModule(permission)
                        }
                    }
                    this.cidade = data.end_cidade
                    this.onChangeUF()
                    /**
                     * Desabilita a obrigatoriedade de inserir senha, pois é uma edição
                     */
                    this.rules_validate.senha[0].required = false
                    /**
                     * Caso o usuário não tenha privilégios suficientes, ele não pode alterar o cargo
                     */
                    if (!this.permissaoAlterar) {
                        this.cargos = this.cargos.filter(
                            cargo => cargo.id_cargo == data.usuario_cargo
                        )
                    }
                    this.getDepartamentos()
                    this.onSelectDep()

                    setTimeout(() => {
                        this.ativar_botao = false
                    }, 100)
                    this.$Spin.hide()
                } catch (error) {
                    console.warn(error)
                    this.$Spin.hide()
                }
            },
            /**
             * Quando houver alterações no CEP, faz a consulta no viaCep
             */
            async onCEP() {
                const cep = this.dados_usuario.end_cep
                const res = await consultarCEP(cep)
                /**
                 * Caso seja um CEP válido, preenche automaticamente o endereço
                 */
                if (res) {
                    this.dados_usuario.end_rua = res.logradouro
                    this.dados_usuario.end_bairro = res.bairro
                    this.dados_usuario.end_cidade = res.localidade
                    this.dados_usuario.end_estado = res.uf
                    this.cidade = res.localidade
                    this.onChangeUF()
                }
            },

            onSelectDep() {
                this.cargos_filtro = this.cargos.filter(
                    item =>
                        item.departamento == this.dados_usuario.usuario_departamento
                )
            },

            async getCargos() {
                try {
                    const URI = "pessoa/cargos"
                    const {data} = await this.$axios.get(URI)
                    this.cargos = data
                    this.getDepartamentos()
                } catch (ex) {
                    console.warn(ex)
                }
            },

            getDepartamentos() {
                this.departamentos = this.cargos.reduce((departamentos, cargo) => {
                    if (!departamentos.includes(cargo.departamento)) {
                        departamentos.push(cargo.departamento)
                    }
                    return departamentos
                }, [])
            },
            /**
             * Consulta os estados do País
             */
            async getEstados() {
                try {
                    const URI = "consulta/regions"
                    const {data} = await this.$axios.get(URI)
                    this.estados = _.orderBy(data,['estado'],['asc'])
                } catch (ex) {
                    console.warn(ex)
                }
            },
            /**
             * Ao escolher um estado no input, consulta as cidades deste estado
             */
            async onChangeUF() {
                const uf = this.dados_usuario.end_estado
                try {
                    const URI = `consulta/regions/${uf}/cities`
                    const {data} = await this.$axios.get(URI)
                    this.cidades = data
                    this.dados_usuario.end_cidade = this.cidade
                    this.dados_usuario.end_estado = parseInt(uf)
                } catch (ex) {
                    console.warn(ex)
                }
            },
            /**
             * Consulta os modulos disponiveis do sistema
             */
            async getModules(){
                try {
                    const {data} = await this.$axios.get("modulos")
                    let modules = data.modules
                    let children = data.children
                    this.modules = modules.map(item =>{
                        item["children"] = children.filter(value => {
                            return item.id == value.id
                        })
                        return item
                    }).filter(item =>{
                        // remove os modulos padrao para todos usuarios
                        return item.id != 1 && item.id != 2
                    })
                } catch (ex) {
                    console.warn(ex)
                }
            },
            /**
             * Adiciona ou remove todos os filhos do modulo selecionado
             */
            setAllModule(item,key) {
                if (item.value){
                    if(item.children.length>0){
                        item.children.map(item => {
                            this.permissions.push(item)
                            this.permission.push(item.label+item.value)
                        })
                    } else {
                        this.permissions.push({"id":item.id,"label":item.label})
                        this.permission.push(item.label)
                    }
                    this.modules[key].icon = "done"
                } else {
                    this.permissions = this.permissions.filter(value =>{
                        if (value.label != item.label) {
                            return item
                        }
                    })
                    item.children.map(item =>{
                        this.permission = this.permission.filter(value =>{
                            if(item.label+item.value != value){
                                return value
                            }
                        })
                    })
                }
                this.dados_usuario.permissao = _.uniqWith(this.permissions, _.isEqual)
            },
            /**
             * Seleciona ou remove o item do modulo
             */
            setItemPermission(item,children,key) {
                if(this.permission.includes(item.label+children.value)){
                    this.permissions.push(children)
                } else {
                    this.permissions = this.permissions.filter(value =>{
                        return value.label+value.value != item.label+children.value
                    })
                }
                let all = 0
                item.children.map(value => {
                    if(this.permission.includes(value.label+value.value)){
                        all++
                    }
                })

                if(item.children.length == all){
                    this.modules[key].icon = "done"
                    this.modules[key].value = true
                } else {
                    if (all>0) {
                        this.modules[key].icon = "remove"
                        this.modules[key].value = true
                    } else {
                        this.modules[key].value = false
                    }
                }
                this.dados_usuario.permissao = _.uniqWith(this.permissions, _.isEqual)
            },

            setModule(permission){
                this.permission = []
                this.permissions = []
                this.modules.map((item,key) => {
                    item.value = false
                    if(item.children.length>0){
                        item.children.map(children =>{
                            permission.map(value => {
                                if(children.label == value.label && children.value == value.value){
                                    this.permission.push(item.label+children.value)
                                    this.setItemPermission(item,children,key)
                                }
                            })
                        })
                    } else {
                        permission.map(value => {
                            if(item.label == value.label){
                                item["value"] = true
                                this.permission.push(item.label)
                                this.setAllModule(item,key)
                            }
                        })
                    }
                })
            }
        },
        watch: {
            /**
             * Observa alterações nos dados, para exibir o botão de salvar
             */
            dados_usuario: {
                handler() {
                    this.ativar_botao = true
                },
                deep: true
            },
            'dados_usuario.usuario_cargo'(newValue, oldValue){
                if(oldValue!="" && newValue!=null){
                    let permission = JSON.parse(this.cargos.filter(item =>{
                        return item.id_cargo == newValue
                    })[0].permissao_padrao)
                    if(permission){
                        this.setModule(permission)
                    }
                }
            }
        }
    }
</script>
<style scoped>
    .ivu-form-item {
        height: 59px;
    }
</style>
